export default __webpack_public_path__ + "static/media/shopping-list-2.807407a9.svg";